import { ChevronLeft, ChevronRight } from 'lucide-react'
import type * as React from 'react'
import { DayPicker } from 'react-day-picker'
import styles from 'react-day-picker/dist/style.module.css'
import { cn } from '~/lib/utils'

export type CalendarProps = React.ComponentProps<typeof DayPicker>

const Calendar = ({
	className,
	classNames,
	showOutsideDays = false,
	...props
}: CalendarProps) => {
	return (
		<DayPicker
			showOutsideDays={showOutsideDays}
			className={cn('p-3', className)}
			classNames={{
				months: 'flex flex-col gap-10',
				tbody: 'border-0',
				button:
					'!text-xs rounded-full h-[32px] w-[32px] flex items-center justify-center cursor-pointer',
				caption: 'relative',
				caption_label: `${styles.caption_label} capitalize !font-medium !text-lg justify-center w-full h-[32px]`,
				nav: 'absolute top-0 left-0 right-0 z-10 flex justify-between items-center px-1',
				nav_button: '!text-slate-500 hover:bg-slate-100',
				nav_button_next: '!ml-auto',
				head_cell: 'text-xs h-[32px] !w-[32px] font-normal opacity-50',
				cell: '!h-[32px] w-[32px]',
				day: 'hover:bg-slate-100',
				day_selected:
					'bg-primary text-white hover:!bg-primary !border-none !font-bold group',
				day_today: 'border',
				day_disabled: 'opacity-30 hover:!bg-transparent !cursor-default',
				day_range_start: '!rounded-r-none',
				day_range_end: '!rounded-l-none',
				day_range_middle:
					'!rounded-none !bg-primary/15 !text-primary/20 hover:!text-primary/20 hover:!bg-primary/15',
				...classNames,
			}}
			components={{
				IconLeft: ({ ...props }) => <ChevronLeft className='size-4' />,
				IconRight: ({ ...props }) => <ChevronRight className='size-4' />,
			}}
			{...props}
		/>
	)
}

Calendar.displayName = 'Calendar'

export { Calendar }
